import React from 'react';
import { BillingSummaryReport as BillingSummaryReportData } from '../../models/Report';
import { ExportDropdown } from './ExportDropdown';
import { rowsToCsv, downloadCsv, todayStamp } from '../../utils/csv';

interface Props {
  data: BillingSummaryReportData;
  onBack?: () => void;
}

export const BillingSummaryReport: React.FC<Props> = ({ data }) => {
  const handleExportCSV = () => {
    const csv = rowsToCsv(data.billingCodeBreakdown, [
      { header: 'Code', get: (r) => r.code },
      { header: 'Description', get: (r) => r.description },
      { header: 'Count', get: (r) => r.count },
      { header: 'Hours', get: (r) => r.hours },
      { header: 'Rate', get: (r) => r.rate ?? '' },
      { header: 'Revenue', get: (r) => r.revenue ?? '' },
    ]);
    downloadCsv(`billing-summary_${todayStamp()}.csv`, csv);
  };

  return (
  <div>
    {/* Toolbar */}
    <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 'var(--spacing-4)' }}>
      <ExportDropdown onExportCSV={handleExportCSV} />
    </div>

    <div className="grid grid-cols-2" style={{ gap: 'var(--spacing-4)', marginBottom: 'var(--spacing-6)' }}>
      <div className="card">
        <div style={{ fontSize: 'var(--text-sm)', color: 'var(--color-gray-600)' }}>
          Total Billable Hours
        </div>
        <div style={{ fontSize: 'var(--text-3xl)', fontWeight: 'var(--font-bold)' }}>
          {data.totalBillableHours}
        </div>
      </div>
      <div className="card">
        <div style={{ fontSize: 'var(--text-sm)', color: 'var(--color-gray-600)' }}>
          Billing Codes Used
        </div>
        <div style={{ fontSize: 'var(--text-3xl)', fontWeight: 'var(--font-bold)' }}>
          {data.billingCodeBreakdown.length}
        </div>
      </div>
    </div>

    <div className="card" style={{ marginBottom: 'var(--spacing-6)' }}>
      <h3 style={{ marginBottom: 'var(--spacing-4)' }}>Billing Code Breakdown</h3>
      <div className="table-container">
        <table className="table">
          <thead>
            <tr>
              <th>Code</th>
              <th>Description</th>
              <th>Count</th>
              <th>Hours</th>
            </tr>
          </thead>
          <tbody>
            {data.billingCodeBreakdown.map((code) => (
              <tr key={code.code}>
                <td><strong>{code.code}</strong></td>
                <td>{code.description}</td>
                <td>{code.count}</td>
                <td>{code.hours}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>

    <div className="card">
      <h3 style={{ marginBottom: 'var(--spacing-4)' }}>By RBT</h3>
      <div className="table-container">
        <table className="table">
          <thead>
            <tr>
              <th>RBT Name</th>
              <th>Total Hours</th>
              <th>Billing Codes</th>
            </tr>
          </thead>
          <tbody>
            {data.byRBT.map((rbt) => (
              <tr key={rbt.rbtId}>
                <td>{rbt.rbtName}</td>
                <td>{rbt.totalHours}</td>
                <td>
                  {Object.entries(rbt.billingCodes).map(([code, hours]) => (
                    <div key={code}>
                      {code}: {hours}h
                    </div>
                  ))}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  </div>
  );
};
